import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import clsx from 'clsx';
import { vitalStyles } from '../styles';
import { BodyTextMedium, HeadingText50 } from '../Typography/Typography';
import { pxToRem } from '../../helpers/pxToRem';
import { IconButton } from '../IconButton/IconButton';
import * as styles from './Modal.module.scss';
var ComponentNames;
(function (ComponentNames) {
    ComponentNames["Modal"] = "Modal";
    ComponentNames["ModalOverlay"] = "ModalOverlay";
})(ComponentNames || (ComponentNames = {}));
export var ModalTestID;
(function (ModalTestID) {
    ModalTestID["CloseModal"] = "ModalTestID.CloseModal";
    ModalTestID["ModalClosed"] = "ModalTestID.ModalClosed";
    ModalTestID["ModalOpened"] = "ModalTestID.ModalOpened";
})(ModalTestID || (ModalTestID = {}));
export const Modal = ({ title, description, onCloseButtonClick, children, maxWidth, noPaddings = false, isVisible, }) => {
    const modalRef = useRef(null);
    const overlayRef = useRef(null);
    useEffect(() => {
        if (isVisible && modalRef.current) {
            disableBodyScroll(modalRef.current);
        }
        else {
            clearAllBodyScrollLocks();
        }
        return () => {
            clearAllBodyScrollLocks();
        };
    }, [isVisible]);
    useEffect(() => {
        if (!onCloseButtonClick) {
            return;
        }
        const handleOutsideClick = (event) => {
            if (modalRef.current &&
                event.target instanceof HTMLElement &&
                modalRef.current.contains(event.target)) {
                return;
            }
            else if (overlayRef.current &&
                event.target instanceof HTMLElement &&
                overlayRef.current.contains(event.target)) {
                onCloseButtonClick();
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [overlayRef, onCloseButtonClick]);
    return (_jsx("div", { className: styles.overlay, ref: overlayRef, "data-is-visible": isVisible, "data-testid": isVisible ? ModalTestID.ModalOpened : ModalTestID.ModalClosed, "data-component": ComponentNames.ModalOverlay, children: _jsxs("div", { role: "dialog", "aria-hidden": !isVisible, "aria-label": title || 'No title', ref: modalRef, className: clsx([
                styles.container,
                noPaddings ? vitalStyles.noPadding : styles.padding,
            ]), style: maxWidth ? { maxWidth: pxToRem(maxWidth) } : {}, "data-component": ComponentNames.Modal, children: [onCloseButtonClick && (_jsx(IconButton, { title: "Dismiss", className: styles.closeContainer, onClick: onCloseButtonClick, "data-testid": ModalTestID.CloseModal, icon: "x", size: "medium", variant: "secondary" })), title && _jsx(HeadingText50, { marginBottom: 12, children: title }), description && (_jsx(BodyTextMedium, { marginBottom: 12, children: description })), _jsx("div", { className: clsx([
                        styles.content,
                        !noPaddings && !title && !description && styles.contentOnly,
                        noPaddings && vitalStyles.noMargin,
                    ]), children: children })] }) }));
};
